import { usePermissionsRepository } from '@Hooks/useRepository';
import { ApplicationsRepository } from '@Repositories/Permissions';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useUnblockExternalApplication = (applicationId: string, onMutate: () => void) => {
    const applications = usePermissionsRepository(ApplicationsRepository);

    const { mutateAsync, isPending: unblockApplicationIsPending } = useMutation({
        mutationFn: () => applications.unblockApplication(applicationId),
    });

    const unblockApplicationHandler = useCallback(async () => {
        await mutateAsync();
        onMutate();
    }, [mutateAsync, onMutate]);

    return { unblockApplicationHandler, unblockApplicationIsPending };
};
